import TypedText from '../typedText/TypedText';
import "./style.css";

const Header = ({ title, subtitle, subtitle_2, text, typedTextStrings, link, button_text}) => {
  return (
    <header className="header flow">
      <div className="header__wrapper">
        <h1 className="header__title">
          <strong>{title} <em>{subtitle}</em></strong><br />
          {subtitle_2} <TypedText typedTextStrings={typedTextStrings} />
        </h1>

        <div className="header__text">
          <p>{text}</p>
        </div>
        <a href={link} className="btn">
          {button_text}
        </a>
      </div>
    </header>
  );
}

export default Header;
